import { render } from "./VTableUint.vue?vue&type=template&id=23b8fbdc&scoped=true"
const script = {}

import "./VTableUint.vue?vue&type=style&index=0&id=23b8fbdc&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b8fbdc"]])

export default __exports__